/**
 * useKey : renameKey
 */

export const CHECKOUT_FLOOR_TYPE = {
  // 地址
  ADDRESS_FLOOR: {
    ADDRESS_FLOOR_NAMESPACE: "core.trade-FLR#balance.address-M#defaultAddressFloor",
    STRUCTURE: {
      "C-M#defaultAddressFloor&affiliation": {
        defaultAddress: "defaultAddress",
      },
      "VCYBB2C-D#addressHint&basic": {
        newAddressMsg: "newAddressMsg",
      },
      "C-M#defaultAddressFloor&coordinate": {
        latitude: "latitude",
        longitude: "longitude",
      },
      "C-M#defaultAddressFloor&area": {
        areaCode: "areaCode",
        areaIdMap: "areaIdMap",
        areaNameMap: "areaNameMap",
      },
      "C-M#defaultAddressFloor&privacy": {
        starredMobile: "starredMobile",
        encryptedName: "encryptedName",
        encryptedAddressDetail: "encryptedAddressDetail",
        encryptedFullAddress: "encryptedFullAddress",
      },
      "C-M#defaultAddressFloor&core": {
        addressId: "addressId",
      },
      "C-D#addressTag&basic": {
        tagName: "tagName",
      },
      "VCYBB2C-D#venderPickTip&vednerPickTip": {
        venderPickTip: "venderPickTip",
      },
      "VCRYPE-D#venderPickTip&vednerPickTip": {
        venderPickTip: "venderPickTip",
      },
    },
  },
  // 店铺
  VENDER_FLOOR: {
    VENDER_FLOOR_NAMESPACE: "core.trade-FLR#balance.vender-M#defaultVenderFloor",
    STRUCTURE: {
      "C-M#venderFloor&core": {
        venderName: "venderName",
        venderId: "venderId",
      },
    },
  },
  // 配送
  SHIPMENT_FLOOR: {
    SHIPMENT_FLOOR_NAMESPACE: "core.trade-FLR#balance.shipment-M#shipmentHomePageFloor",
    STRUCTURE: {
      "C-M#shipmentHomePageFloor&basic": {
        shipmentType: "shipmentType",
        shipmentUuid: "shipmentUuid",
      },
      "VCYBB2C-D#shipmentInfo&classify": {
        venderId: "venderId",
      },
      "C-M#abstractShipmentFloor&basic": {
        shipmentName: "shipmentName",
        availableFlag: "availableFlag",
        selectedFlag: "selectedFlag",
      },
      "C-M#abstractShipmentFloor&core": {
        shipmentId: "shipmentId",
      },
    },
  },
  // 备注
  REMARK_FLOOR: {
    REMARK_FLOOR_NAMESPACE: "core.trade-FLR#balance.remark-M#defaultRemarkFloor",
    STRUCTURE: {
      "C-M#remarkFloor&basic": {
        isShow: "isShow",
      },
      "C-D#venderRemark&vender": {
        relationUUIDs: "relationUUIDs",
      },
    },
  },
  // 商品
  PRODUCT_FLOOR: {
    PRODUCT_FLOOR_NAMESPACE: "core.trade-FLR#balance.product-M#retailProductFloor",
    STRUCTURE: {
      "C-M#retailProductFloor&numInfo": {
        unit: "unit",
        numMsg: "numMsg",
        num: "num",
      },
      "C-M#retailProductFloor&basic": {
        skuName: "skuName",
        imageUrl: "imageUrl",
        skuId: "skuId",
        productType: "productType",
        secKillFlag: "secKillFlag",
      },
      "C-M#retailProductFloor&price": {
        price: "price",
        priceShow: "priceShow",
        secKillPrice: "secKillPrice",
        deliveryPrice: "deliveryPrice",
      },
      "C-M#retailProductFloor&stock": {
        stockStatusCode: "stockStatusCode",
      },
      "C-D#promotionInfo&basic": {
        ptFlag: "ptFlag",
        ptPrice: "ptPrice",
        jdPrice: "jdPrice", // 划线价格
        unitPromoDiscount: "unitPromoDiscount",
        isHitSumPromo: "isHitSumPromo", // 是否总价促销
        sumPromoId: "sumPromoId", // 总价促销Id
      },
    },
    PART_LIST_NAMESPACE: "core.trade-FLR#balance.order-P#dimAttributePart",
    PART_LIST_STRUCTURE: {
      "C-P#dimAttributePart&basic": {
        saleValue: "saleValue",
      },
    },
  },
  // 虚拟组套
  VIRTUAL_PRODUCT_FLOOR: {
    VIRTUAL_PRODUCT_FLOOR_NAMESPACE: "core.trade-FLR#balance.product-M#virtualProductFloor",
    STRUCTURE: {
      "C-M#productFloor&core": {
        modelType: "modelType",
      },
      "C-M#virtualProductFloor&basic": {
        num: "num",
        suitNum: "suitNum",
        titleName: "titleName",
      },
      "C-D#promotionInfo&basic": {
        promotionName: "promotionName",
        promotionTags: "promotionTags",
        discount: "discount",
        rePrice: "rePrice",
        promoId: "promoId",
      },
    },
  },
  // 虚拟组套虚商品
  VIRTUAL_COMMODITY_FLOOR: {
    VIRTUAL_COMMODITY_FLOOR_NAMESPACE: "core.trade-FLR#balance.product-M#virtualCommodityFloor",
    STRUCTURE: {
      "C-M#productFloor&core": {
        modelType: "modelType",
      },
      "C-M#virtualProductFloor&basic": {
        skuName: "skuName",
        numMsg: "numMsg",
        imageUrl: "imageUrl",
        priceShow: "priceShow",
        skuId: "skuId",
        price: "price",
      },
    },
  },
  // 总价促销
  TOTAL_PRICE_FLOOR: {
    TOTAL_PRICE_FLOOR_NAMESPACE: "core.trade-FLR#balance.product-M#totalPriceProductFloor",
    STRUCTURE: {
      "C-D#promotionInfo&basic": {
        manfanMoney: "manfanMoney",
        promotionName: "promotionName",
        promotionTags: "promotionTags",
        fullRefundType: "fullRefundType",
        needMoney: "needMoney",
        discount: "discount",
        rePrice: "rePrice",
        jdPrice: "jdPrice",
        promoId: "promoId",
      },
      "C-M#productFloor&core": {
        modelType: "modelType",
      },
    },
  },
  // 加价购商品
  ADDITIONAL_PRODUCT_FLOOR: {
    ADDITIONAL_PRODUCT_FLOOR_NAMESPACE: "core.trade-FLR#balance.product-M#additionalProductFloor",
    STRUCTURE: {
      "C-M#additionalProductFloor&basic": {
        mainSkuId: "mainSkuId",
        giftType: "giftType",
        canBuyWithoutGift: "canBuyWithoutGift",
        titleTag: "titleTag",
      },
      "C-M#retailProductFloor&category": {
        firstCategoryId: "firstCategoryId",
        secondCategoryId: "secondCategoryId",
        thirdCategoryId: "thirdCategoryId",
      },
      "C-M#retailProductFloor&numInfo": {
        numMsg: "numMsg",
        num: "num",
      },
      "C-M#retailProductFloor&basic": {
        skuName: "skuName",
        imageUrl: "imageUrl",
        skuId: "skuId",
        productType: "productType",
        secKillFlag: "secKillFlag",
      },
      "C-M#retailProductFloor&price": {
        price: "price",
        priceShow: "priceShow",
        secKillPrice: "secKillPrice",
      },
      "C-M#retailProductFloor&stock": {
        stockStatusCode: "stockStatusCode",
      },
      "C-D#promotionInfo&basic": {
        promotionTags: "promotionTags",
        discount: "discount",
        rePrice: "rePrice",
        jdPrice: "jdPrice",
        // addFlag: 'addFlag',
        // addPrice: "addPrice"
      },
      "C-M#productFloor&core": {
        modelType: "modelType",
      },
    },
    PART_LIST_NAMESPACE: "core.trade-FLR#balance.order-P#dimAttributePart",
    PART_LIST_STRUCTURE: {
      "C-P#dimAttributePart&basic": {
        saleName: "saleName",
        saleValue: "saleValue",
      },
    },
  },
  // 总计-0元单标识
  AMOUNT_FLOOR: {
    AMOUNT_FLOOR_NAMESPACE: "core.trade-FLR#balance.order-M#defaultOrderAmountFloor",
    STRUCTURE: {
      "C-M#orderAmountFloor&core": {
        // receivableAmount: "receivableAmount",
        zeroOrderText: "zeroOrderText",
        isZeroOrder: "isZeroOrder",
      },
    },
  },
  // 支付楼层
  PAYMENT_FLOOR: {
    PAYMENT_FLOOR_NAMESPACE: "core.trade-FLR#balance.payment-M#paymentInfoFloor",
    STRUCTURE: {
      "C-P#paymentType&paymentType": {
        paymentName: "paymentName",
        selected: "selected",
        supported: "supported",
        icon: "iconUrl",
        payToolName: "payToolName",
      },
    },
    PART_LIST_STRUCTURE: {
      "C-P#paymentType&paymentType": {
        isSelect: "selected",
        icon: "iconUrl",
        payToolId: "payToolId",
        payToolName: "payToolName",
        payMethod: "payMethod",
        payEnum: "payEnum",
        integrationType: "integrationType",
        enabled: "enabled",
        prompt: "prompt",
        supportBrands: "supportBrands",
        tips: "tips",
        unselectTips: "unselectTips",
        rememberInfos: "rememberInfos",
      },
    },
  },
  // 优惠券楼层
  COUPON_FLOOR: {
    COUPON_FLOOR_NAMESPACE: "core.trade-FLR#balance.coupon-M#homePageFloorCouponFloor",
    STRUCTURE: {
      "C-M#homePageFloorCouponFloor&number": {
        selectedCouponNum: "selectedCouponNum",
        availableNum: "availableNum",
        usedNum: "usedNum",
      },
      "C-M#homePageFloorCouponFloor&money": {
        couponDiscount: "couponDiscount",
        discountAmount: "discountAmount",
      },
      "C-M#homePageFloorCouponFloor&selectCoupon": {
        couponId: "couponId",
        batchId: "batchId",
        couponType: "coupionType",
        /** 优惠券使用门槛 */
        quota: "quota",
      },
    },
  },
  // 快递运输时效
  PROMISE_FLOOR: {
    PROMISE_FLOOR_NAMESPACE: "core.trade-FLR#balance.shipment-M#defaultPromiseHomePageFloor",
    PART_LIST_NAMESPACE: "core.trade-FLR#balance.shipment-P#homePagePromisePart",
    PART_LIST_STRUCTURE: {
      "C-P#homePagePromisePart&basic": {
        defaultPromiseMsg: "defaultPromiseMsg",
      },
    },
    STRUCTURE: {
      "C-M#defaultPromiseHomePageFloor&label": {
        promiseLabel: "promiseLabel",
        promiseDateDescShow: "deliveryDateDesc",
      },
      "C-M#defaultPromiseHomePageFloor&basic": {
        promiseDateDescShow: "deliveryDateDesc",
        promiseDateShow: "deliveryDate",
      },
    },
  },
  // 门店自提
  PICK_FLOOR: {
    PICK_FLOOR_NAMESPACE: "cn_ybxt_b2c-FLR#balance.shipment-M#venderPickFloor",
    STRUCTURE: {
      "VCYBB2C-M#venderPickFloor&basic": {
        venderStoreName: "name",
        venderStoreDate: "defaultPromiseMsg",
      },
      "VCYBB2C-M#venderPickFloor&stock": {
        storeStockStatus: "storeStockStatus",
      },
    },
  },
  // 运费金额
  FREIGHT_AMOUNT_FLOOR: {
    FREIGHT_AMOUNT_FLOOR_NAMESPACE: "core.trade-FLR#balance.freight-M#totalFreightFloor",
    STRUCTURE: {
      "C-M#totalFreightFloor&core": {
        totalFreightMoney: "amount",
        totalFreightShow: "amountShow",
        freightLabel: "label",
        originalTotalFreight: "originalAmount",
        originalTotalFreightShow: "originalAmountShow",
        discountFreight: "discountedShippingFee",
        tipFlag: "iconFlag",
        subTip: "iconText",
      },
    },
  },
  // 商品金额
  PRODUCT_AMOUNT_FLOOR: {
    PRODUCT_AMOUNT_FLOOR_NAMESPACE:
      "core.trade-FLR#balance.productAmount-M#defaultProductAmountFloor",
    STRUCTURE: {
      "C-M#productAmountFloor&basic": {
        amount: "amount",
        floorType: "floorType",
        amountDetail: "amountDetail",
        label: "label",
        subLabel: "subLabel",
        factAmount: "factAmount",
      },
    },
  },
  // 积分楼层
  POINT_FLOOR: {
    POINT_FLOOR_NAMESPACE: "core.trade-FLR#balance.points-M#defaultPointsFloor",
    STRUCTURE: {
      "C-M#abstractPointsFloor&count": {
        totalCount: "totalCount",
        canUseCount: "canUseCount",
        useCount: "useCount",
        discount: "discount",
        minUseUnit: "minUseUnit",
        rate: "rate",
      },
      "C-M#abstractPointsFloor&useRule": {
        useRuleTitle: "useRuleTitle",
        useRuleContent: "useRuleContent",
      },
      "VCYBB2C-D#pointsDetail&msg": {
        useRuleMsg: "useRuleMsg",
        useHighLimit: "useHighLimit",
        useLowLimit: "useLowLimit",
      },
      "C-M#abstractPointsFloor&flag": {
        usedFlag: "usedFlag",
        showFlag: "showFlag",
      },
    },
    PART_LIST_NAMESPACE: "cn_ybxt_b2c-FLR#balance.points-P#detailPart",
    PART_LIST_STRUCTURE: {
      "VCYBB2C-P#detailPart&basic": {
        partUsePointCount: "partUsePointCount",
        partPointDiscount: "partPointDiscount",
        partSelectFlag: "partSelectFlag",
      },
    },
  },
  // 商品库存&&图片域名&&货币符号楼层标志
  PRODUCT_STOCK_FLOOR: {
    PRODUCT_STOCK_NAMESPACE: "core.trade-FLR#balance.product-M#allProductFloor",
    STRUCTURE: {
      "C-M#allProductFloor&basic": {
        stockStatus: "stockStatus",
        isAllHappyHour: "isAllHappyHour",
      },
      "C-D#imgInfo&basic": {
        imageDomain: "imageDomain",
        currencyCode: "currencyCode",
      },
    },
  },
  // 预售默认楼层标志
  PRESALE_DEFAULT_FLOOR: {
    PRESALE_DEFAULT_NAMESPACE: "core.trade-FLR#balance.presale-M#presaleDefaultFloor",
    STRUCTURE: {
      "C-M#abstractPresaleFloor&core": {
        payStepType: "payStepType",
        stage: "stage",
        factPayType: "1",
        factEarnest: "factEarnest",
        factEndPayment: "factEndPayment",
        earnestAfterCoupon: "earnestAfterCoupon",
        presaleFreight: "presaleFreight",
        endPaymentBeginTime: "endPaymentBeginTime",
        endPaymentEndTime: "endPaymentEndTime",
        presaleFlag: "presaleFlag",
        deductionAmount: "deductionAmount",
      },
    },
  },
  // 预售定金期楼层标志
  PRESALE_DEPOSIT_FLOOR: {
    PRESALE_DEPOSIT_NAMESPACE: "core.trade-FLR#balance.presale-M#presaleTotalDepositFloor",
    STRUCTURE: {
      "C-M#presaleTotalDepositFloor&basic": {
        agreePayDeposit: "agreePayDeposit",
        depositAmount: "depositAmount",
        refundDeposit: "refundDeposit",
        refundDepositMsg: "refundDepositMsg",
        depositTitle: "depositTitle",
      },
    },
  },
  // 预售手机号
  PRESALE_MOBILE_FLOOR: {
    PRESALE_MOBILE_NAMESPACE: "core.trade-FLR#balance.presale-M#presaleMobileFloor",
    STRUCTURE: {
      "C-M#presaleMobileFloor&core": {
        userMobile: "userMobile",
      },
    },
  },
};
